export function formatNumber(num: number, maxFractionDigits: number) {
  return new Intl.NumberFormat("pl-PL", {
    maximumFractionDigits: maxFractionDigits,
  }).format(num);
}
